import { Renderer2, Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';

export const SCRIPTS = {
  // yandex metrika
  ym: `
    (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
    m[i].l=1*new Date();k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
    (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");
    
    ym(86949282, "init", {
        clickmap:true,
        trackLinks:true,
        accurateTrackBounce:true,
        webvisor:true
    });
    `,
  google: {
    url:
      `
    https://www.googletagmanager.com/gtag/js?id=G-4M044MSFFQ%22%3E
    `,
    init:
      `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', 'G-4M044MSFFQ');
    `,
  }
  ,
  // used to update styles.css link href - add slash at the start
  stylesCssLinkPatching: `
    const stylesheets = document.getElementsByTagName('link');
    const node = [...stylesheets].find((s) => s.getAttribute('href').includes('styles'));
    const href = node.getAttribute('href');
    node.setAttribute('href', '/' + href);`,
};

/**
 * Service for injecting JS scripts on the fly at the runtime.
 */
@Injectable({ providedIn: 'root' })
export class ScriptsService {
  constructor(@Inject(DOCUMENT) private document: Document) { }

  /**
   * Append the JS tag to the Document Body by link.
   *
   * @param src The path to the script
   * @returns the script element
   */
  loadJsScript(renderer: Renderer2, src: string): HTMLScriptElement {
    const script = renderer.createElement('script');
    script.type = 'text/javascript';
    script.src = src;
    renderer.appendChild(this.document.head, script);
    return script;
  }

  /**
   * Append the JS tag to the Document Head by text.
   *
   * @param text The text to be inserted in the script tag
   * @returns the script element
   */
  insertJsScriptText(renderer: Renderer2, text: string): HTMLScriptElement {
    const script = renderer.createElement('script');
    script.type = 'text/javascript';
    renderer.appendChild(script, renderer.createText(text));
    renderer.appendChild(this.document.head, script);
    return script;
  }
}
